/* eslint-disable max-len */

import { defineMessages } from 'react-intl';

export const addons = defineMessages({
  title: {
    id: 'addons.title',
    description: 'Create addon page title',
    defaultMessage: 'Create an add-on'
  },
  cancel: {
    id: 'addons.cancel',
    description: 'Cancel edit/create',
    defaultMessage: 'Cancel',
  },
  addOnName: {
    id: 'addons.addOnName',
    description: 'add-on name question',
    defaultMessage: 'What is your add-on called?'
  },
  addOnNamePlaceholder: {
    id: 'addons.addOnNamePlaceholder',
    description: 'Add-on name placeholder',
    defaultMessage: 'Add-on name'
  },
  addOnNameBlankErrorMessage: {
    id: 'addons.addOnNameBlankErrorMessage',
    description: 'Blank add-on name error message',
    defaultMessage: 'Add-on name is required'
  },
  addOnDetails: {
    id: 'addons.addOnDetails',
    description: 'Add-on details',
    defaultMessage: 'Add-on details'
  },
  optionNamesErrorMessage: {
    id: 'addons.optionNamesErrorMessage',
    description: 'Blank option name error message',
    defaultMessage: 'An option name is required'
  },
  optionUsedErrorMessage: {
    id: 'addons.optionUsedErrorMessage',
    defaultMessage: 'You cannot remove an option that has already been sold.'
  },
  basicInformation: {
    id: 'addons.basicInformation',
    description: 'Basic Information',
    defaultMessage: 'Basic Information'
  },
  addOnNameLengthErrorMessage: {
    id: 'addons.addOnNameLengthErrorMessage',
    description: 'Error message when character length of name is less than 95',
    defaultMessage: 'Add-on name must be less than 95 characters'
  },
  addOnDescriptionLengthErrorMessage: {
    id: 'addons.addOnDescriptionLengthErrorMessage',
    description: 'Error message when character length of description is more than 400',
    defaultMessage: 'Add-on description must be less than 400 characters'
  },
  postPurchaseMessageLengthErrorMessage: {
    id: 'addons.postPurchaseMessageLengthErrorMessage',
    description: 'Error message when character length of post purchase message is more than 400',
    defaultMessage: 'Add-on post purchase message must be less than 400 characters'
  },
  describeAddOn: {
    id: 'addons.describeAddOn',
    description: 'Describe your add-on',
    defaultMessage: 'How would you describe your add-on?'
  },
  describeAddOnSubheading: {
    id: 'addons.describeAddOnSubheading',
    description: 'Describe your add-on',
    defaultMessage: 'Description will appear during checkout.'
  },
  describeAddOnPlaceholder: {
    id: 'addons.describeAddOnPlaceholder',
    description: 'Add-on description placeholder',
    defaultMessage: 'Tell buyers what they need to know about what you are selling. Keep it short and simple'
  },
  errorFlashMessage: {
    id: 'addons.errorFlashMessage',
    description: 'add-ons error message',
    defaultMessage: 'Oops! Something went wrong. Please try again.'
  },
  selectCurrency: {
    id: 'addons.selectCurrency',
    description: 'Select currency header',
    defaultMessage: 'Add-on currency'
  },
  selectCurrencyTitle: {
    id: 'basics.selectCurrencyTitle',
    description: 'Select currency',
    defaultMessage: 'Select currency'
  },
  nameInput: {
    id: 'addons.nameInput',
    description: 'Option',
    defaultMessage: 'Option'
  },
  nameInputPlaceHolder: {
    id: 'addons.nameInputPlaceholder',
    description: 'Small',
    defaultMessage: 'Small'
  },
  priceInput: {
    id: 'addons.priceInput',
    description: 'Price',
    defaultMessage: 'Price'
  },
  priceInputPlaceHolder: {
    id: 'addons.priceInputPlaceholder',
    description: 'Free',
    defaultMessage: 'Free'
  },
  priceInputErrorMessage: {
    id: 'addons.priceInputErrorMessage',
    description: 'Price is required',
    defaultMessage: 'Price is required'
  },
  capacityInput: {
    id: 'addons.capacityAvailabilityInput',
    description: 'Quantity Available',
    defaultMessage: 'Total quantity'
  },
  capacityInputPlaceholder: {
    id: 'addons.capacityInputPlaceholder',
    description: 'Unlimited',
    defaultMessage: 'Unlimited'
  },
  skuInput: {
    id: 'addons.skuInput',
    description: 'SKU',
    defaultMessage: 'SKU'
  },
  skuInputPlaceholder: {
    id: 'addons.skuInputPlaceholder',
    description: 'SKU or product name',
    defaultMessage: 'SKU or product name'
  },
  minQuantityInputPlaceholder: {
    id: 'addons.minQuantityInputPlaceholder',
    description: 'Min',
    defaultMessage: 'Max'
  },
  maxQuantityInputPlaceholder: {
    id: 'addons.maxQuantityInputPlaceholder',
    description: 'Max',
    defaultMessage: 'Max'
  },
  minMaxQuantityInput: {
    id: 'addons.minMaxQuantityInput',
    description: 'Min/max quantity per order',
    defaultMessage: 'Min/max quantity per order'
  },
  eventsCheckBox: {
    id: 'addons.eventsCheckBox',
    description: 'Event checkbox label',
    defaultMessage: 'This add-on will be available on all events transacting in {currencyCode}'
  },
  saveAsDraft: {
    id: 'addons.saveAsDraft',
    description: 'Save as draft',
    defaultMessage: 'Save as draft'
  },
  createAddon: {
    id: 'addons.createAddon',
    description: 'Create add-on',
    defaultMessage: 'Save add-on'
  },
  saveAddon: {
    id: 'addons.save',
    description: 'Save',
    defaultMessage: 'Save'
  },
  taxes: {
    id: 'addons.taxes',
    description: 'Taxes',
    defaultMessage: 'Taxes'
  },
  taxMessage: {
    id: 'addons.taxMessage',
    description: 'Tax message for add-ons',
    // This surface has no styled asterisk span, so the marker is part of the string.
    defaultMessage:
      'You are responsible for all local tax laws. Universe does not withhold or remit taxes collected on your behalf. *Some jurisdictions require taxes to be itemized — please be sure to itemize taxes where required.'
  },
  taxNameInput: {
    id: 'addons.taxNameInput',
    description: 'Tax name',
    defaultMessage: 'Tax name'
  },
  taxNameInputPlaceholder: {
    id: 'addons.taxNameInputPlaceholder',
    description: 'Ex. GST',
    defaultMessage: 'E.g. GST'
  },
  taxPercentInput: {
    id: 'addons.taxPercentInput',
    description: 'Tax rate',
    defaultMessage: 'Tax rate'
  },
  taxPercentInputPlaceholder: {
    id: 'addons.taxPercentInputPlaceholder',
    description: 'Ex. 5',
    defaultMessage: 'E.g. 5'
  },
  taxRegNumInput: {
    id: 'addons.taxRegNumInput',
    description: 'Tax registration number',
    defaultMessage: 'Tax registration #'
  },
  feesAndTaxes: {
    id: 'addons.feesAndTaxes',
    description: 'Fees and taxes',
    defaultMessage: 'Fees and taxes'
  },
  feeMessage: {
    id: 'addons.feeMessage',
    description: 'Fee message for add-on',
    defaultMessage: 'Who pays Universe Service Fee'
  },
  feeSelectDisabled: {
    id: 'addons.feeSelectDisabled',
    description: 'Fee selection disabled message',
    defaultMessage: 'This feature has been disabled by a sales representative for tax reasons.' +
     'Please contact them if you have any questions or concerns.'
  },
  absorbFees: {
    id: 'addons.absorbFees',
    description: 'Absorb fee into addon price',
    defaultMessage: 'Absorb into price'
  },
  passFeesToBuyer: {
    id: 'addons.passFeesToBuyer',
    description: 'pass addon fee to the buyer',
    defaultMessage: 'Pass fees to the buyer'
  },
  addOption: {
    id: 'addons.addOption',
    description: 'Add Option',
    defaultMessage: 'Add Option'
  },
  addTax: {
    id: 'addons.addTax',
    description: 'Add tax',
    defaultMessage: 'Add tax'
  },
  addNewTax: {
    id: 'addons.addNewTax',
    description: 'Add a new tax',
    defaultMessage: 'Add a new tax'
  },
  customTaxSelection: {
    id: 'addons.customTaxSelection',
    description: 'Custom Tax Selection Label',
    defaultMessage: 'Create new tax'
  },
  selectTax: {
    id: 'addons.selectTax',
    description: 'Select tax placeholder',
    defaultMessage: 'Select tax'
  },
  eventsTitle: {
    id: 'addons.eventsTitle',
    description: 'Events section title',
    defaultMessage: 'Events Selector'
  },
  eventsSubtitle: {
    id: 'addons.eventsSubtitle',
    description: 'Explain assigning add-ons to listings',
    defaultMessage: 'Make this add-on available for'
  },
  editEventsButton: {
    id: 'addons.editEventsButton',
    description: 'Edit events',
    defaultMessage: 'Edit events'
  },
  photo: {
    id: 'addons.photo',
    description: 'Add-on photo',
    defaultMessage: 'Add-on photo'
  },
  uploadHeader: {
    id: 'addons.uploadHeader',
    description: 'Add photo',
    defaultMessage: 'Add photo'
  },
  uploadBody: {
    id: 'addons.uploadBody',
    description: 'add-on photo dimensions',
    defaultMessage: '(min 100x100px, max 2mb)'
  },
  optionInvalidPriceErrorMessage: {
    id: 'addons.optionInvalidPriceErrorMessage',
    description: 'Invalid price',
    defaultMessage: 'Invalid price'
  },
  optionQuantityErrorMessage: {
    id: 'addons.optionQuantityErrorMessage',
    description: 'Invalid quantity',
    defaultMessage: 'Invalid quantity',
  },
  postPurchaseMessageHeader: {
    id: 'addons.postPurchaseMessageHeader',
    description: 'Post-purchase add-on message',
    defaultMessage: 'Post-purchase add-on message',
  },
  postPurchaseMessageSubheader: {
    id: 'addons.postPurchaseMessageSubheader',
    description: 'This message will appear on the order confirmation email and on the add-on itself.',
    defaultMessage: 'This message will appear on the order confirmation email and on the add-on itself.',
  },
  showPostPurchaseMessage: {
    id: 'addons.showPostPurchaseMessage',
    description: 'Add post-purchase add-on message',
    defaultMessage: 'Add post-purchase add-on message',
  },
  hidePostPurchaseMessage: {
    id: 'addons.hidePostPurchaseMessage',
    description: 'Remove post-purchase add-on message',
    defaultMessage: 'Remove post-purchase add-on message',
  },
  cancelTax: {
    id: 'addons.tax.cancel',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  saveTax: {
    id: 'addons.tax.save',
    description: 'Save new tax',
    defaultMessage: 'Save new tax',
  },
  savingTax: {
    id: 'addons.tax.saving',
    description: 'Saving',
    defaultMessage: 'Saving',
  },
  deleteOption: {
    id: 'addons.option.delete',
    description: 'Delete option',
    defaultMessage: 'Delete option',
  },
  addOnsDescriptions: {
    id: 'addons.description',
    description: 'Addons description',
    defaultMessage: 'Create and customize additional items that can be purchased' + 
     'during checkout to enhance the fan experience and increase average order value.',
  },
  printedTicketCharactersDisplayingLimit: {
    id: 'addons.printedTicketCharactersDisplayingLimit',
    description: 'Printed tickets character limit',
    defaultMessage: 'For printed tickets we will only be able to display 15 characters.'
  },
  addPhoto: {
    id: 'addons.addPhoto',
    description: 'Add Photo',
    defaultMessage: 'Add Photo'
  },
  changePhoto: {
    id: 'addons.changePhoto',
    description: 'Change Photo',
    defaultMessage: 'Change Photo'
  },
  available: {
    id: 'addons.available',
    description: 'Available',
    defaultMessage: 'Available'
  },
  sold: {
    id: 'addons.sold',
    description: 'Sold',
    defaultMessage: 'Sold'
  },
  cannotDeleteSoldOutRate: {
    id: 'addons.deleteRate',
    description: 'You cannot delete an add-on option that has already been sold.',
    defaultMessage: 'You cannot delete an add-on option that has already been sold.'
  },
  qrCodeHeading: {
    id: 'addons.qrCodeHeading',
    description: "Best for add-ons that don't require redemption in the future.",
    defaultMessage: "Best for add-ons that don't require redemption in the future."
  },
  hideQrCode: {
    id: 'addons.hideQrCode',
    description: 'Hide QR Code',
    defaultMessage: 'Hide QR Code'
  }
});
